module.exports = __webpack_public_path__ + "img/Snorre_Christian_Krohg.5e61b1a8.jpg";